import React, { FC } from 'react'

import Chip from '@mui/material/Chip'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'

import { FETCH_STRIPE_PRODUCTS } from 'saas/stripe/gql'
import { Service } from 'shared/types'
import apolloAdminClient from 'clients/apollo/admin'

export const ServicePlansTable: FC = () => {
  const [products, setProducts] = React.useState<any[]>([])

  const fetchProducts = async () => {
    try {
      const { data } = await apolloAdminClient.query({ query: FETCH_STRIPE_PRODUCTS })
      const { allStripeProducts } = data
      setProducts(allStripeProducts)
    } catch (e) {
      console.error(e)
    }
  }

  React.useEffect(() => {
    fetchProducts()
  }, [])

  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Group</TableCell>
            <TableCell>Product</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Price</TableCell>
            <TableCell>Metadata</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {products.map((product, i) => {
            const { stripeObject: stripeProduct, status, group } = product
            const { prices } = stripeProduct

            return (
              <TableRow key={i}>
                <TableCell>{group}</TableCell>
                <TableCell>
                  <div>
                    <a href={`https://dashboard.stripe.com/test/products/${stripeProduct.id}`}>{stripeProduct.name}</a>
                  </div>
                  <div>
                    <small>{stripeProduct.description}</small>
                  </div>
                </TableCell>
                <TableCell>{status}</TableCell>
                <TableCell>
                  {prices.map((price) => (
                    <Chip
                      key={price.id}
                      label={`${price.chargeAmount.formattedAmount} / ${price.recurring.interval}`}
                    />
                  ))}
                </TableCell>
                <TableCell>{stripeProduct.id}</TableCell>
              </TableRow>
            )
          })}
        </TableBody>
      </Table>
    </TableContainer>
  )
}
